import React, { useEffect, useState } from "react";
import { Avatar } from "@material-ui/core";
import "../css/Post.css";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import NearMeIcon from "@material-ui/icons/NearMe";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { ExpandMoreOutlined } from "@material-ui/icons";
import db from "../firebase";
import { useStateValue } from "../StateProvider";
import Comment from "./Comment";
import { Link } from "react-router-dom";

import PostSubMenu from "./PostSubMenu";

function Post({
  postId,
  postedBy,
  image,
  timestamp,
  message,
  likes,
  comments,
  loading,
}) {
  const [{ user, userProfile }] = useStateValue();
  const [likeActivate, setLikeActivate] = useState(false);
  const [commentBox, setCommentBox] = useState(false);
  const [subMenu, setSubMenu] = useState(false);

  //check if this should have submenu
  useEffect(() => {
    if (postedBy.username === userProfile.username) {
      setSubMenu(true);
    }
  }, []);

  /* Check if likes array already has uer.uid */

  const handleLike = (e) => {
    e.stopPropagation();
    setLikeActivate(!likeActivate);

    // console.log(likes.indexOf(user.uid) >= 0); //true
    var updateRef = db.collection("posts").doc(e.target.dataset.postid);
    if (likes.indexOf(userProfile.name) >= 0) {
      //already like // Remove uid from likes array

      updateRef
        .update({
          likes: likes.filter((e) => e !== userProfile.name),
        })
        .then(function () {
          console.log("Document successfully updated!");
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });

      setLikeActivate(!likeActivate);
    } else {
      //not likeyet

      updateRef
        .update({
          likes: [...likes, userProfile.name],
        })
        .then(function () {
          console.log("Document successfully updated!");
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
      setLikeActivate(!likeActivate);
    }
  };

  useEffect(() => {
    //get initial state for like button
    //if array contain user.displayName
    // console.log(likes);
    if (likes.indexOf(userProfile.name) >= 0) {
      setLikeActivate(true);
    }
  }, [likes, userProfile]);

  /* COMMENT */
  const openComment = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setCommentBox(!commentBox);
    // console.log(comments);
  };

  // Check if have comment , open comment box
  useEffect(() => {
    if (comments.length > 0) {
      setCommentBox(true);
    }
  }, [comments]);

  return (
    <div className="post">
      <div className="post__top">
        <Avatar className="post__avatar" src={postedBy.profilePic} />
        <div className="post__topInfo">
          <h3>
            <Link to={`/profile/${postedBy.username}`}>{postedBy.name}</Link>
          </h3>
          <p>{new Date(timestamp?.toDate()).toUTCString()}</p>
        </div>
        {subMenu && <PostSubMenu postId={postId} />}
      </div>
      <div className="post__bottom">
        <p>{message}</p>
      </div>
      <div className="post__image">{<img src={image} alt="" />}</div>

      <div className="post__data">
        {likes.length > 0 && (
          <>
            <ThumbUpIcon />
            <ul>
              {likes.map(function (name, index) {
                return <li key={index}>{name}</li>;
              })}
            </ul>
            <p>Like</p>
          </>
        )}
      </div>

      <div className="post__options">
        {likeActivate ? (
          <div
            className="post__option post__option__like post__option__active"
            onClick={handleLike}
            data-postid={postId}
          >
            Like
          </div>
        ) : (
          <div
            className="post__option post__option__like"
            onClick={handleLike}
            data-postid={postId}
          >
            Like
          </div>
        )}

        <div
          className="post__option post__option__comment"
          onClick={openComment}
        >
          {/* <ChatBubbleOutlineIcon /> */}
          Comment
        </div>

        <div className="post__option">
          <NearMeIcon />
          <p>Share</p>
        </div>
        <div className="post__option">
          <AccountCircleIcon />
          <ExpandMoreOutlined />
        </div>
      </div>
      {commentBox && <Comment comments={comments} postId={postId} />}
    </div>
  );
}

export default Post;
